import { apiWrapper } from 'ccs-ui-components';
import { headersInstance } from '../../../common/utils/HeaderUtils';
import { IActiveJourney } from '../../store/actions/types/sources/GetAllJourneys';

/**
 * @method useServiceDependencyGraph
 * @description Custom hook to make get the journey graph API call
 * @returns journey api response
 */
const useServiceDependencyGraph = () => {
  const getServiceDependencyGraph = async (
    serviceName: string,
    version: string,
    pageNo: string,
    itemPerPage: number,
    sortingOrder: string,
    statusList: string[] | undefined,
    searchText?: string
  ) => {
    const isStatusEmpty = statusList?.[0] === '';
    const journeys = [{
      journeyName: searchText ?? undefined
    }];

    const body = {
      journeys: searchText ? journeys : undefined,
      statusList: !isStatusEmpty ? statusList : undefined,
      service: {
        serviceName,
        version
      },
      exactNameMatch: false
    };

    const resp = await apiWrapper.post<IActiveJourney, { errorMessage: string }>(
      `${process.env.REACT_APP_API_CONTROL_PLANE_SERVICE_BASE_URL}/journeys/search?page=${pageNo}&size=${itemPerPage}&sort=${sortingOrder}`,
      body,
      headersInstance()
    );

    if (resp.isError) {
      return {
        errorMessage: resp.errorBody?.errorMessage,
        isError: true,
        statusCode: resp.statusCode
      };
    }
    const graphResponse = resp.responseBody;
    return {
      graphResponse,
      isError: resp.isError,
      statusCode: resp.statusCode
    };
  };

  return { getServiceDependencyGraph };
};

export default useServiceDependencyGraph;
